import { Controller } from "@hotwired/stimulus"

// Schaltet das Erfassungsformular der Gegenzeichnung zwischen den beiden Formen um:
// Unterschrift auf dem Gerät (Pad) oder auf Papier (Upload des unterschriebenen
// Ausdrucks, GB-20b). Nur Sichtbarkeit — welche Form gespeichert wird, sagt das Radio.
export default class extends Controller {
  static targets = ["onScreen", "paper"]

  switch(event) {
    const paper = event.target.value === "paper"
    this.onScreenTarget.classList.toggle("hidden", paper)
    this.paperTarget.classList.toggle("hidden", !paper)
  }
}
